import { CheckoutState } from '../../state';
import { areAsyncExpressApplePayEligibleRulesMet } from './areAsyncExpressApplePayEligibleRulesMet';
import { areSyncExpressApplePayEligibleRulesMet } from './areSyncExpressApplePayEligibleRulesMet';

export const isExpressApplePayEnabled = (state: CheckoutState) =>
    areSyncExpressApplePayEligibleRulesMet(state) &&
    areAsyncExpressApplePayEligibleRulesMet(state);
